// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jBQHQdiHKU6YpD1C5UDLq"};